import { Dispatch } from "@reduxjs/toolkit";
import { api } from "../config/api";
import { axiosClient } from "../config/axios";
import {
    getReportRequest,
    getReportFailure,
    getReportSuccess,
    getDataPaymentRequest,
    getDataPaymentSuccess,
    getDataPaymentFailure,
    getPaymentProcessRequest,
    getPaymentProcessSuccess,
    getPaymentProcessFailure,
    cleanReport as cleanReportReducer
} from '../reducers/report';

export const getLinkPayment = (body: ReportProps) => (dispatch: Dispatch) => _getLinkPayment(body, dispatch);
const _getLinkPayment = async (body: ReportProps, dispatch: Dispatch) => {
    try {
        dispatch({ type: getReportRequest });

        const response = await axiosClient.post(
            `${api.icar}/reports`,
            body
        );
        dispatch({
            type: getReportSuccess,
            payload: response?.data
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.error('Error getting link payment:', errorResponse?.code || error.message);
        dispatch({ type: getReportFailure });
    }
};

export const cleanReport = () => (dispatch: Dispatch) => _cleanReport(dispatch);
const _cleanReport = (dispatch: Dispatch) => dispatch({ type: cleanReportReducer });

export const getDataPayment = (body: ReportProps) => (dispatch: Dispatch) => _getDataPayment(body, dispatch);
const _getDataPayment = async (body: ReportProps, dispatch: Dispatch) => {
    try {
        dispatch({ type: getDataPaymentRequest });

        const response = await axiosClient.post(
            `${api.payments}/payment-processes/public`,
            body
        );
        dispatch({
            type: getDataPaymentSuccess,
            payload: response?.data
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.error('Error getting link payment:', errorResponse?.code || error.message);
        dispatch({ type: getDataPaymentFailure });
    }
};

export const getPaymentProcess = (body: ReportProps) => (dispatch: Dispatch) => _getPaymentProcess(body, dispatch);
const _getPaymentProcess = async (body: ReportProps, dispatch: Dispatch) => {
    try {
        dispatch({ type: getPaymentProcessRequest });

        const response = await axiosClient.get(
            `${api.payments}/payment-processes/public/${body}`,
        );
        dispatch({
            type: getPaymentProcessSuccess,
            payload: response?.data
        });
    } catch (error: any) {
        const errorResponse = error?.response?.data?.error;
        console.error('Error getting link payment:', errorResponse?.code || error.message);
        dispatch({ type: getPaymentProcessFailure });
    }
};
